// @ts-nocheck

import { createSelector } from 'reselect';

import { type Selector } from '../../../types/selectors';

import {
  selectClientUpdaterHasDismissTheWarnAtLeastOnce,
  selectIsClientUpdateDeprecated,
  selectIsClientUpdateMandatory,
} from './clientUpdaterPrimary.selector';

export const selectIsClientUpdaterDialogOpen: Selector<boolean> = createSelector(
  [selectIsClientUpdateDeprecated, selectIsClientUpdateMandatory, selectClientUpdaterHasDismissTheWarnAtLeastOnce],
  (isClientDeprecated, isClientUpdateMandatory, hasDismissTheWarnAtLeastOnce) =>
    isClientUpdateMandatory || (isClientDeprecated && !hasDismissTheWarnAtLeastOnce),
);
